var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "scenario-list-item" }, [
    _c("div", { staticClass: "scenario-list-item-header content-container" }, [
      _c("div", { staticClass: "scenario-list-image-container" }, [
        _vm.scenario.imageUrl
          ? _c("img", {
              staticClass: "scenario-list-image",
              attrs: { src: _vm.scenario.imageUrl }
            })
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("hr")
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "scenario-list-item-body content-container" }, [
      _c(
        "div",
        { staticClass: "scenario-list-item-content" },
        [
          _c(
            "span",
            {
              staticClass:
                "scenario-list-item-title dmv-text dmv-text-primary dmv-text-large"
            },
            [
              _vm._v(
                "\n                " +
                  _vm._s(_vm.scenario.name) +
                  "\n            "
              )
            ]
          ),
          _vm._v(" "),
          _c("span", { staticClass: "dmv-text dmv-text-secondary" }, [
            _vm._v(
              "\n                " +
                _vm._s(_vm.scenario.description) +
                "\n            "
            )
          ]),
          _vm._v(" "),
          _vm._t("description-bottom")
        ],
        2
      )
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "scenario-list-item-footer content-container" },
      [_vm._t("bottom")],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }